import { cn, Icon } from '@shared/cove-ui';
import { HTMLAttributes } from 'react';

const CartIcon = ({
  count,
  className,
  ...props
}: { count: number } & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      aria-hidden
      {...props}
      className={cn(
        'pl-cove-2 sm:mr-cove-35 sm:ml-cove-15 text-cove-blue relative flex w-[38px] min-w-[38px] items-center justify-center bg-transparent bg-contain bg-center bg-no-repeat pb-[3px] text-[8px] font-medium leading-[8px] sm:h-[58px]',
        className
      )}
    >
      <Icon
        icon="Cart"
        className="text-cove-navy-blue -mb-cove-2 -ml-cove-2 absolute size-9 *:size-9"
      />
      {count > 0 ? count : null}
    </div>
  );
};

export default CartIcon;
